import { post, get } from './request'


export let loadFinding = (findingId, success, failure) => get(`/api/findings/${findingId}`, success, failure)
export let loadFalsePositiveTypes = (findingId, success, failure) => get(`/api/findings/${findingId}/false-positive-types`, success, failure)
export let saveFalsePositive = (payload, success, failure) => post(`/api/findings/${payload.findingId}/false-positive`, payload, success, failure)